import Resource from "./resource";

export enum UpgradeNotificationMode {
    AlwaysShow = "AlwaysShow",
    ShowOnlyMajorMinor = "ShowOnlyMajorMinor",
    NeverShow = "NeverShow"
}

export class UpgradeConfigurationResource extends Resource {
    NotificationMode: UpgradeNotificationMode;
}

export default UpgradeConfigurationResource;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/upgradeConfigurationResource.ts